($traceurRuntime.createClass)($__placeholder__0, $__placeholder__1, $__placeholder__2)


/** WEBPACK FOOTER **
 ** ../@traceur/generated/TemplateParser/8
 **/